var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.406a.844.844 0 1 1 0 1.688H3.75a.844.844 0 0 1 0-1.688zM8.906 15.75v-6a.844.844 0 0 1 1.688 0v6a.844.844 0 0 1-1.688 0m4.5 0v-6a.844.844 0 0 1 1.688 0v6a.844.844 0 0 1-1.688 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.594 19.5A1.594 1.594 0 0 1 18 21.094H6A1.594 1.594 0 0 1 4.406 19.5V5.25a.844.844 0 0 1 1.688 0v14.156h11.812V5.25a.844.844 0 0 1 1.688 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.906 5.25v-1.5a.656.656 0 0 0-.623-.655l-.033-.001h-4.5a.656.656 0 0 0-.656.656v1.5a.844.844 0 0 1-1.688 0v-1.5A2.344 2.344 0 0 1 9.75 1.406h4.5a2.344 2.344 0 0 1 2.344 2.344v1.5a.844.844 0 0 1-1.688 0"
  })));
};
export default SvgTrash;